/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Copy, BodyCopy, Icon, Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './requeststatus_styles';



/* ========== ~~~~~~~~~~ AUTH NEW INVITATION SENT ~~~~~~~~~~ ========== */
const NoRequest = (props) => {
    const getButtonText = () => props.mockupGenerator ? `Create the commenting unit` : 'Request the commenting unit';
    return (
        <div className={`requeststatus ${props.classes.requeststatus}`}>
            <Copy>
                <BodyCopy>
                    <div className={'title'}>Start the conversation</div>
                    <p>Engage your audience with Insticator’s new comment widget.</p>
                    <ul>
                        <li className={'norequestlistitem'}>
                            <Icon name={'balance-scale'} />
                            <span>
                            All comments are moderated by our 24/7 human moderation team. Anyone can game a system meant for filtering out bad words but our trained moderators make sure all trolls and hate speech is not your concern.
                            </span>
                        </li>
                        <li className={'norequestlistitem'}>
                            <Icon name={'money-bill-wave'}/>
                            <span>Earn more revenue with ad units above the commenting unit.</span>
                        </li>
                    </ul>
                </BodyCopy>
                <Button text={getButtonText()} variant={'primary'} type={'action'} operation={'load'} disabled={props.buttonDisabled} processing={props.requestPending} handleClick={props.sendRequest}/>
            </Copy>
        </div>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(NoRequest);
